<section class="section-edit-tooltip-container"
         dbStopPinchEvent
         (click)="onClick($event)"
         *ngIf="page">
  <div class="section-type-container" *ngIf="modifiedSectionType">
    {{modifiedSectionType}} {{ 'text_section' | dbText }}
  </div>
  <db-canvas-tour-tooltip
    *ngIf="!canvasTourService.shownTour[newTourEnum.EDIT_SECTION]"
    (dbClickOutside)="closeTour()"
    [oneLine]="false"
    [tour]="tour">
  </db-canvas-tour-tooltip>
  <div class="ds-input-wrap mb30">
    <div class="ds-textarea-label-wrap with-enhance">
      <span class="field-label">{{ 'text_title' | dbText }}</span>
    </div>
    <input [formControl]="page.section.title_control"
           [class.disabled]="loading$|async"
           (focus)="closeTour()"
           (blur)="onBlur()"
           [placeholder]="'text_sectionTitle' | dbText"
           (keydown)="$event.stopPropagation()"
           class="ds-input ds-input-black"/>
    <span class="ds-input-error-msg"
          *ngIf="page?.section?.title_control.touched && !page?.section?.title_control?.value && page?.section?.description_control.value && !((loading$|async) && loadingFor === 'title')">
      <span class="suggest-title" (click)="suggest('title')">{{ 'text_getASuggestionFromAi' | dbText }}</span>
    </span>
    <span class="ds-input-desc" *ngIf="(loading$|async) && loadingFor === 'title'">
      <db-loading-circular-spinner
        [color]="'monochrome'"
        [size]="'xs_small'"
        [newMode]="true"
        class="mr6"></db-loading-circular-spinner>
      {{ 'text_generating' | dbText }}
    </span>
  </div>

  <div class="ds-input-wrap mb9">
    <div class="ds-textarea-label-wrap with-enhance">
      <span class="field-label">{{ 'text_sectionPrompt' | dbText }}</span>
      <a class="generate-ai" *ngIf="page?.section?.title_control?.value || page?.section?.description_control.value"
         [class.ds-disabled]="(loading$|async)">
        @if ((loading$|async) && (loadingFor === 'description' || loadingFor === 'enhance')) {
        <db-loading-circular-spinner
          *ngIf="(loading$|async) && (loadingFor === 'description' || loadingFor === 'enhance')"
          [color]="'monochrome'"
          [size]="'xs_small'"
          [newMode]="true"
          class="mr6"></db-loading-circular-spinner>
        } @else {
        <img src="assets/images/icons/enhance_with_ai_active.svg">
        }
        @if ((loading$|async) && (loadingFor === 'description' || loadingFor === 'enhance')) {
        <span>Generating...</span>
        } @else if (!page.section.description_control.value) {
        <span (click)="suggest('description')">{{ 'text_suggestDescriptionWithAi' | dbText }}</span>
        } @else {
        <span (click)="suggest('enhance')">{{ 'text_enhanceWithAi' | dbText }}</span>
        }
      </a>
    </div>
    <textarea [attr.maxLength]="1000"
              [class.disabled]="loading$|async"
              (blur)="onBlur()"
              (focus)="closeTour()"
              (keydown)="$event.stopPropagation()"
              [formControl]="page.section.description_control"
              class="ds-textarea ds-textarea-black no-resize"
              rows="6"></textarea>
  </div>


  <a class="generate-ai mb20" *ngIf="!page.section.description_control.value && !page.section.title_control.value">
    @if((loading$|async) && loadingFor === 'new'){
    <span class="loading">
       <db-loading-circular-spinner
         [color]="'monochrome'"
         [size]="'xs_small'"
         [newMode]="true"
         class="mr6"></db-loading-circular-spinner>
    Generating...
    </span>
    }@else{
    <img src="assets/images/icons/enhance_with_ai_active.svg" class="mr10">
    <span (click)="suggest('new')">{{ 'text_getSectionSuggestionWithAi' | dbText }}</span>
    }
  </a>

  <div class="section-edit-tooltip-footer">
    <div>
      <i (click)="removeSection($event)" class="db-icon db-icon-ds-recicle-bin"></i>
      <span (click)="removeSection($event)">{{ 'text_removeSection' | dbText }}</span>
    </div>
  </div>
</section>
